export interface AdsState {
  googletagIsLoaded: boolean;
  currentCycle: AdCycle;
  thirdpartyads: boolean;
}

export interface AdMessage {
  messageId: string;
  src?: string;
  type?: string;
  aspect?: string;
  fullSiteBranding?: string;
  fullSiteBackgroundColor?: string;
  active?: string;
  linkUrl?: string;
}

export interface AdCycle {
  id: number | null;
  targetings: {
    [key: string]: string | string[];
  };
  slotsRendered: {
    [adPath: string]: {
      event: SlotRenderedEvent;
      timestamp: number;
    };
  };
  messages: {
    [messageId: string]: AdMessage;
  };
}

export const initialState: AdsState = {
  googletagIsLoaded: false,
  currentCycle: {
    id: null,
    targetings: {},
    slotsRendered: {},
    messages: {},
  },
  thirdpartyads: null,
};

export type SlotRenderedEvent = Omit<googletag.events.SlotRenderEndedEvent, 'slot'>;

export interface RenderedAdEvent {
  serviceName: string;
  isEmpty: boolean;
  slotContentChanged: boolean;
  size: number[];
  advertiserId: number;
  campaignId: number;
  creativeId: number;
  creativeTemplateId?: number;
  labelIds?: number[];
  lineItemId: number;
  sourceAgnosticCreativeId: number;
  sourceAgnosticLineItemId: number;
  isBackfill: boolean;
  yieldGroupIds?: number[];
  companyIds?: number[];
  eventSource: number;
}
